(() => {
  const $ = (s, el = document) => el.querySelector(s);
  const $$ = (s, el = document) => [...el.querySelectorAll(s)];
  const T = Object.assign({ homes_one: '%n woning', homes_other: '%n woningen', in_area: ' in %s', for_guests: ' voor %n+ gasten', show_all: 'Toon alle %n woningen ', cars_one: '%n auto', cars_other: "%n auto's", guests_one: '%n gast', guests_other: '%n gasten', save: 'Bewaar', remove: 'Verwijder', step: 'Stap %n van %t', date_error: 'Kies een vertrekdatum na de aankomstdatum.' }, window.R24_T || {});
  const fmt = (str, n, extra) => String(str).replace('%n', n).replace('%s', extra == null ? '' : extra).replace('%t', extra == null ? '' : extra);
  const plural = (key, n) => fmt(T[key + (n === 1 ? '_one' : '_other')], n);
  const store = {
    get(k) { try { return JSON.parse(localStorage.getItem(k)); } catch (e) { return null; } },
    set(k, v) { try { localStorage.setItem(k, JSON.stringify(v)); } catch (e) {} },
    sget(k) { try { return JSON.parse(sessionStorage.getItem(k)); } catch (e) { return null; } },
    sset(k, v) { try { sessionStorage.setItem(k, JSON.stringify(v)); } catch (e) {} }
  };

  /* header: mobile menu + scroll state */
  const header = $('[data-r-header]');
  const burger = $('[data-r-burger]');
  const mobile = $('#r-mobile-nav');
  burger?.addEventListener('click', () => {
    const open = burger.getAttribute('aria-expanded') !== 'true';
    burger.setAttribute('aria-expanded', String(open));
    mobile.hidden = !open;
  });
  mobile?.addEventListener('click', (e) => { if (e.target.closest('a')) { mobile.hidden = true; burger.setAttribute('aria-expanded', 'false'); } });
  const onScroll = () => header?.classList.toggle('is-scrolled', window.scrollY > 40);
  window.addEventListener('scroll', onScroll, { passive: true });
  onScroll();

  /* language/currency dropdown: close on outside click or Escape */
  document.addEventListener('click', (e) => { $$('[data-r-loc][open]').forEach((d) => { if (!d.contains(e.target)) d.open = false; }); });
  document.addEventListener('keydown', (e) => { if (e.key === 'Escape') $$('[data-r-loc][open]').forEach((d) => { d.open = false; }); });

  /* reveal on scroll */
  const reveals = $$('.r-reveal');
  if ('IntersectionObserver' in window) {
    const io = new IntersectionObserver((entries) => entries.forEach((en) => { if (en.isIntersecting) { en.target.classList.add('is-in'); io.unobserve(en.target); } }), { rootMargin: '0px 0px -8% 0px' });
    reveals.forEach((el) => io.observe(el));
  } else reveals.forEach((el) => el.classList.add('is-in'));

  /* house card photo sliders */
  $$('[data-r-slider]').forEach((media) => {
    const imgs = $$('.r-house__img', media);
    const dots = $$('.r-dots i', media);
    const label = $('[data-r-label]', media);
    if (imgs.length < 2) return;
    let i = 0;
    const load = (im) => { if (im && im.dataset.src) { im.srcset = im.dataset.srcset || ''; im.src = im.dataset.src; delete im.dataset.src; delete im.dataset.srcset; } };
    media.addEventListener('pointerenter', () => load(imgs[1]), { once: true });
    const show = (n) => {
      i = (n + imgs.length) % imgs.length;
      load(imgs[i]); load(imgs[(i + 1) % imgs.length]);
      imgs.forEach((im, k) => { im.classList.toggle('is-active', k === i); if (k === i && im.loading === 'lazy') im.loading = 'eager'; });
      dots.forEach((d, k) => d.classList.toggle('is-active', k === i));
      if (label) label.textContent = imgs[i].dataset.label + ' · ' + (i + 1) + '/' + imgs.length;
    };
    $('[data-r-prev]', media)?.addEventListener('click', (e) => { e.preventDefault(); show(i - 1); });
    $('[data-r-next]', media)?.addEventListener('click', (e) => { e.preventDefault(); show(i + 1); });
  });

  /* favourites (per bezoeker) */
  const favs = store.get('r24-favs') || {};
  $$('[data-r-fav]').forEach((btn) => {
    const id = btn.dataset.rFav;
    const name = btn.dataset.name || '';
    const paint = () => {
      const on = !!favs[id];
      btn.setAttribute('aria-pressed', String(on));
      btn.setAttribute('aria-label', (on ? T.remove : T.save) + ' ' + name);
    };
    paint();
    btn.addEventListener('click', (e) => { e.preventDefault(); favs[id] = !favs[id]; store.set('r24-favs', favs); paint(); });
  });

  /* house filtering (homepage + collectie) */
  const list = $('[data-r-houses]');
  if (list) {
    const cards = $$('[data-r-house]', list);
    const limit = Number(list.dataset.limit || 0);
    const state = { type: 'alle', area: 'alle', guests: 0, all: !limit };
    const chips = $$('[data-r-type]');
    const areaSel = $('[data-r-area-filter]');
    const result = $('[data-r-result]');
    const clearBtn = $('[data-r-clear]');
    const moreWrap = $('[data-r-more-wrap]');
    const moreBtn = $('[data-r-more]');
    const empty = $('[data-r-empty]');
    const render = () => {
      const match = cards.filter((c) =>
        (state.type === 'alle' || (state.type === 'pool' ? c.dataset.pool === 'true' : c.dataset.type === state.type)) &&
        (state.area === 'alle' || c.dataset.area === state.area) &&
        Number(c.dataset.guests) >= state.guests);
      cards.forEach((c) => { c.hidden = true; });
      match.forEach((c, k) => { c.hidden = !state.all && limit && k >= limit; });
      chips.forEach((b) => b.setAttribute('aria-pressed', String(b.dataset.rType === state.type)));
      if (areaSel) areaSel.value = state.area;
      let t = plural('homes', match.length);
      if (state.area !== 'alle') t += fmt(T.in_area, '', state.area);
      if (state.guests > 0) t += fmt(T.for_guests, state.guests);
      if (result) result.textContent = t;
      const filtered = state.type !== 'alle' || state.area !== 'alle' || state.guests > 0;
      if (clearBtn) clearBtn.hidden = !filtered;
      if (empty) empty.hidden = match.length > 0;
      if (moreWrap) moreWrap.hidden = state.all || !limit || match.length <= limit;
      if (moreBtn) moreBtn.firstChild.textContent = fmt(T.show_all, match.length);
    };
    chips.forEach((b) => b.addEventListener('click', () => { state.type = b.dataset.rType; render(); }));
    areaSel?.addEventListener('change', () => { state.area = areaSel.value; state.all = true; render(); });
    clearBtn?.addEventListener('click', () => { Object.assign(state, { type: 'alle', area: 'alle', guests: 0, all: !limit }); render(); });
    $$('[data-r-clear-all]').forEach((b) => b.addEventListener('click', () => { Object.assign(state, { type: 'alle', area: 'alle', guests: 0, all: !limit }); render(); }));
    moreBtn?.addEventListener('click', () => { state.all = true; render(); });
    $$('[data-r-area-tile]').forEach((a) => a.addEventListener('click', () => { Object.assign(state, { type: 'alle', area: a.dataset.rAreaTile, guests: 0, all: true }); render(); }));
    window.r24Filter = (patch) => { Object.assign(state, patch); render(); };
    const params = new URLSearchParams(location.search);
    if (params.get('gebied')) { state.area = params.get('gebied'); state.all = true; }
    if (params.get('gasten')) state.guests = Number(params.get('gasten')) || 0;
    if (params.get('type')) state.type = params.get('type');
    render();
  }

  /* car category chips (collectie huurauto's) */
  const carList = $('[data-r-cars]');
  if (carList) {
    const cars = $$('[data-r-car]', carList);
    const chips = $$('[data-r-cat]');
    const result = $('[data-r-car-result]');
    const apply = (cat) => {
      let n = 0;
      cars.forEach((c) => { const on = cat === 'alle' || c.dataset.cat === cat; c.hidden = !on; if (on) n++; });
      chips.forEach((b) => b.setAttribute('aria-pressed', String(b.dataset.rCat === cat)));
      if (result) result.textContent = plural('cars', n);
    };
    chips.forEach((b) => b.addEventListener('click', () => apply(b.dataset.rCat)));
    apply('alle');
  }

  /* hero search */
  const search = $('[data-r-search]');
  if (search) {
    const out = $('[data-r-guests-out]', search);
    const input = $('[name="gasten"]', search);
    const paint = () => { out.textContent = plural('guests', Number(input.value)); };
    $('[data-r-dec]', search)?.addEventListener('click', () => { input.value = Math.max(1, Number(input.value) - 1); paint(); });
    $('[data-r-inc]', search)?.addEventListener('click', () => { input.value = Math.min(16, Number(input.value) + 1); paint(); });
    paint();
    search.addEventListener('submit', (e) => {
      const arrival = $('[name="aankomst"]', search).value;
      const departure = $('[name="vertrek"]', search).value;
      const err = $('[data-r-search-error]', search);
      if (arrival && departure && departure <= arrival) { e.preventDefault(); if (err) { err.hidden = false; err.textContent = T.date_error; } return; }
      if (err) err.hidden = true;
      store.sset('r24-trip', { arrival, departure, guests: input.value });
      if (window.r24Filter && $('[data-r-houses]')) {
        e.preventDefault();
        window.r24Filter({ area: $('[name="gebied"]', search).value || 'alle', guests: Number(input.value) || 0, type: 'alle', all: true });
        $('#woningen')?.scrollIntoView({ behavior: 'smooth', block: 'start' });
      }
    });
  }

  /* min dates + prefill request forms with the trip from the search bar */
  const today = new Date();
  const ymd = (d) => d.getFullYear() + '-' + String(d.getMonth() + 1).padStart(2, '0') + '-' + String(d.getDate()).padStart(2, '0');
  $$('input[type=date]').forEach((el) => { el.min = ymd(today); });
  const trip = store.sget('r24-trip');
  if (trip) {
    const a = $('[data-arrival]'), d = $('[data-departure]'), g = $('input[name="contact[Gasten]"]');
    if (a && !a.value && trip.arrival) a.value = trip.arrival;
    if (d && !d.value && trip.departure) d.value = trip.departure;
    if (g && !g.value && trip.guests) g.value = trip.guests;
  }

  /* owner multi-step form */
  const owner = $('[data-r-owner]');
  if (owner) {
    const steps = $$('[data-r-step]', owner);
    const bars = $$('.r-bars i', owner);
    const title = $('[data-r-step-title]', owner);
    const count = $('[data-r-step-count]', owner);
    const back = $('[data-r-back]', owner);
    const next = $('[data-r-next]', owner);
    const submit = $('[data-r-submit]', owner);
    const fileLabel = $('[data-r-files]', owner);
    let s = 0;
    const go = (n) => {
      s = Math.max(0, Math.min(steps.length - 1, n));
      steps.forEach((st, k) => st.classList.toggle('is-active', k === s));
      bars.forEach((b, k) => b.classList.toggle('is-on', k <= s));
      if (title) title.textContent = steps[s].dataset.title;
      if (count) count.textContent = fmt(T.step, s + 1, steps.length);
      back.style.visibility = s > 0 ? 'visible' : 'hidden';
      next.hidden = s === steps.length - 1;
      submit.classList.toggle('is-active', s === steps.length - 1);
    };
    const valid = () => $$('input,select,textarea', steps[s]).every((f) => f.reportValidity());
    next.addEventListener('click', () => { if (valid()) go(s + 1); });
    back.addEventListener('click', () => go(s - 1));
    fileLabel && $('input[type=file]', owner)?.addEventListener('change', (e) => {
      const n = e.target.files ? e.target.files.length : 0;
      fileLabel.textContent = n ? n + (n === 1 ? ' foto gekozen' : ' foto’s gekozen') : fileLabel.dataset.empty;
    });
    go(0);
  }

  /* faq: one open at a time */
  $$('[data-r-faq]').forEach((wrap) => {
    const items = $$('details', wrap);
    items.forEach((d) => d.addEventListener('toggle', () => { if (d.open) items.forEach((o) => { if (o !== d) o.open = false; }); }));
  });

  /* product gallery lightbox */
  const gallery = $$('[data-r-photo]');
  const dlg = $('#r-lightbox');
  if (gallery.length && dlg && dlg.showModal) {
    const img = $('img', dlg), cnt = $('[data-r-lb-count]', dlg);
    let i = 0;
    const show = (n) => { i = (n + gallery.length) % gallery.length; img.src = gallery[i].dataset.full; img.alt = gallery[i].dataset.alt || ''; cnt.textContent = (i + 1) + ' / ' + gallery.length; };
    gallery.forEach((b, k) => b.addEventListener('click', () => { show(k); dlg.showModal(); }));
    $('[data-r-lb-prev]', dlg).addEventListener('click', () => show(i - 1));
    $('[data-r-lb-next]', dlg).addEventListener('click', () => show(i + 1));
    $('[data-r-lb-close]', dlg).addEventListener('click', () => dlg.close());
    dlg.addEventListener('click', (e) => { if (e.target === dlg) dlg.close(); });
    dlg.addEventListener('keydown', (e) => { if (e.key === 'ArrowRight') show(i + 1); if (e.key === 'ArrowLeft') show(i - 1); });
  }

  /* depart after arrive */
  const arrive = $('[data-arrival]'), depart = $('[data-departure]');
  const check = () => {
    if (!arrive || !depart) return;
    depart.setCustomValidity(depart.value && arrive.value && depart.value <= arrive.value ? T.date_error : '');
    if (arrive.value) { const nx = new Date(arrive.value + 'T12:00:00'); nx.setDate(nx.getDate() + 1); depart.min = ymd(nx); }
  };
  arrive?.addEventListener('change', check); depart?.addEventListener('change', check);
})();
